import React from 'react';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';

const InputText = ({
  id,
  handleChange,
  variant,
  value,
  height,
  label,
  fullWidth,
  inputProps,
  className,
  onFocus,
  onBlur,
  placeholder,
  error,
  style,
  disabled,
  gridProps, // Destructure to avoid passing to DOM
  isRequired, // Destructure to avoid passing to DOM
  ...props
}) => (
  <TextField
    onFocus={onFocus}
    onBlur={onBlur}
    placeholder={placeholder}
    onChange={handleChange}
    value={value}
    height={height}
    fullWidth={fullWidth}
    className={className}
    error={error}
    variant={variant}
    label={label}
    disabled={disabled}
    style={style}
    inputProps={inputProps}
    {...props}
    id={id || 'input-text'}
    {...props}
  />
);

InputText.propType = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  variant: PropTypes.string,
  value: PropTypes.string.isRequired,
  height: PropTypes.string,
  label: PropTypes.string,
  fullWidt: PropTypes.string,
  gridProps: PropTypes.object,
};
export default InputText;
